import { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle, XCircle, Clock } from "@phosphor-icons/react";

export default function PaymentResult() {
  const location = useLocation();
  const [params] = useSearchParams();
  const cancelled = location.pathname.includes("cancel");
  const sessionId = params.get("session_id");
  const paypalOrderId = params.get("token");
  const [status, setStatus] = useState(cancelled ? "cancel" : "checking");

  useEffect(() => {
    if (cancelled || !paypalOrderId) return;
    (async () => {
      try {
        const { data } = await api.post("/payments/paypal/capture", { order_id: paypalOrderId });
        setStatus(data.status === "paid" ? "paid" : "timeout");
      } catch { setStatus("failed"); }
    })();
  }, [paypalOrderId, cancelled]);

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
      } catch { /* keep trying */ }
      if (++tries < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId, cancelled]);

  const V = {
    checking: { i: <Clock size={48} className="text-amber-500" />, t: "Vérification du paiement…", d: "Merci de patienter quelques instants." },
    paid: { i: <CheckCircle size={48} weight="fill" className="text-green-600" />, t: "Paiement confirmé !", d: "Votre réservation est confirmée. Retrouvez-la dans « Mes réservations »." },
    cancel: { i: <XCircle size={48} weight="fill" className="text-stone-400" />, t: "Paiement annulé", d: "Vous avez annulé le paiement. Vous pouvez réessayer à tout moment." },
    failed: { i: <XCircle size={48} weight="fill" className="text-red-500" />, t: "Paiement échoué", d: "Le paiement n'a pas abouti. Veuillez réessayer." },
    timeout: { i: <Clock size={48} className="text-amber-500" />, t: "Paiement en cours de traitement", d: "Le statut sera mis à jour sous peu dans vos réservations." },
  }[status];

  return (
    <div className="min-h-screen bg-stone-50 grid place-items-center px-5">
      <div className="bg-white border border-stone-200 rounded-2xl p-10 max-w-md w-full text-center" data-testid="payment-result">
        <div className="flex justify-center mb-4">{V.i}</div>
        <h1 className="font-display text-2xl font-bold text-stone-900">{V.t}</h1>
        <p className="text-stone-500 mt-2">{V.d}</p>
        <div className="flex gap-3 justify-center mt-6">
          <Link to="/bookings"><Button className="rounded-full bg-orange-800 hover:bg-orange-900 text-white">Mes réservations</Button></Link>
          <Link to="/catalog"><Button variant="outline" className="rounded-full">Explorer</Button></Link>
        </div>
      </div>
    </div>
  );
}
